// extracted by mini-css-extract-plugin
module.exports = {"label":"invoiceProduct_label__1_Qkb"};